import { ChakraFlex, ChakraText, FAIconName, Icon } from '@equip.health/ui';

import {
  MAI_CHAT_ERROR_AGENT,
  MAI_CHAT_ERROR_INTERRUPTED,
  MAI_CHAT_ERROR_NETWORK,
  MAI_CHAT_RETRY_CTA,
} from './maiChat.constants';
import { MaiChatErrorKind } from './maiChat.types';

const ERROR_COPY: Record<MaiChatErrorKind, string> = {
  agent: MAI_CHAT_ERROR_AGENT,
  interrupted: MAI_CHAT_ERROR_INTERRUPTED,
  network: MAI_CHAT_ERROR_NETWORK,
};

interface MaiChatErrorNoticeProps {
  kind: MaiChatErrorKind;
  // Carries the kind back so the retry doesn't have to re-read error state that
  // only this notice can be looking at.
  onRetry: (kind: MaiChatErrorKind) => void;
}

const MaiChatErrorNotice = ({ kind, onRetry }: MaiChatErrorNoticeProps) => {
  const message = ERROR_COPY[kind];

  return (
    <ChakraFlex
      data-testid="mai-chat-error"
      data-error-kind={kind}
      role="alert"
      alignItems="center"
      gap="10px"
      padding="10px 12px"
      borderRadius="10px"
      background="error.background"
      border="1px solid"
      borderColor="error.line"
    >
      <Icon
        name={FAIconName.exclamationCircleRegular}
        color="error.primary"
        size="sm"
      />
      <ChakraText color="neutral.primary" fontSize="13px" flex="1">
        {message}
      </ChakraText>
      <ChakraText
        as="button"
        type="button"
        data-testid="mai-chat-error__retry"
        onClick={() => onRetry(kind)}
        color="primary.100"
        fontSize="13px"
        fontWeight="600"
        cursor="pointer"
        whiteSpace="nowrap"
      >
        {MAI_CHAT_RETRY_CTA}
      </ChakraText>
    </ChakraFlex>
  );
};

export default MaiChatErrorNotice;
